import { OptroImportProgressCard } from "./OptroImportProgressCard";
import { useWorkStepOptroImport } from "../contexts/workStepOptroImportContext";
import { useOptroImportInterest } from "../hooks/useOptroImportInterest";
import { OptroImportStage } from "../models/audit/optroSync";

// Shown under the status while a work step is processing, so a long-running
// row says which of the import's tasks it is on (like the document toast's
// pre-process → parse → finalize).
const STAGE_LABEL: Record<OptroImportStage, string> = {
  queued: "Queued",
  fetching: "Fetching from Optro",
  acquiring_documents: "Downloading and parsing workpapers",
  configuring: "Generating attributes and testing table",
  processing: "Processing",
  complete: "Complete",
  failed: "Failed",
};

// The work step import's progress card. Work steps have no "workpaper"
// concept, so a no-workpaper completion reads as "Imported" (a step imported
// without context docs is a shell to refine later, not a failure) and the
// workpaper breakdown is left out. It keeps the tracker polling while it is on
// screen.
export const WorkStepOptroImportProgressPanel = () => {
  const {
    activeJob,
    panelVisible,
    dismissImport,
    pollingFailed,
    retryPolling,
    registerInterest,
  } = useWorkStepOptroImport();
  useOptroImportInterest(panelVisible ? registerInterest : undefined);
  return (
    <OptroImportProgressCard
      activeJob={activeJob}
      panelVisible={panelVisible}
      pollingFailed={pollingFailed}
      onRetry={retryPolling}
      onDismiss={dismissImport}
      noun="work steps"
      noWorkpaperLabel="Imported"
      showWorkpaperBreakdown={false}
      stageLabels={STAGE_LABEL}
    />
  );
};
